import { collection, doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * A recording's key (2026-09-29): trackKeys/{id}, where `detected` is the
 * helper's estimate (written by the fileTrackJob trigger) and `confirmed` is
 * a teacher's correction, the only part a client may write (firestore.rules).
 */
export const subscribeTrackKey = (id, onChange, onError) => {
	if (!id) return () => {};
	return onSnapshot(
		doc(db, 'trackKeys', id),
		(snap) => onChange(snap.exists() ? snap.data() : null),
		(err) => (onError ? onError(err) : console.error('trackKeys listener failed:', err))
	);
};

/** A teacher sets (or clears, with null) the key. Merge: `detected` stays. */
export const confirmTrackKey = (id, key, uid) =>
	setDoc(
		doc(db, 'trackKeys', id),
		{ confirmed: key ? { tonic: key.tonic, mode: key.mode } : null, confirmedBy: uid, confirmedAt: serverTimestamp() },
		{ merge: true }
	);

/** "Find the key": queue one key job for a file (Mac-only; it waits for a Mac). */
export const findTrackKey = async ({ id, file, studentId, studentName = null, song, uid }) => {
	if (!id || !file || !file.storagePath || !studentId || !song) throw new Error('Nothing to listen to.');
	const ref = doc(collection(db, 'trackJobs'));
	await setDoc(ref, {
		kind: 'key',
		keyDocId: id,
		studentId,
		studentName,
		songId: song.canonicalSongId || song.songId || null,
		songName: String(song.name).trim(),
		removeVocals: false,
		source: { storagePath: file.storagePath, storageUrl: file.storageUrl || null, fileName: file.name || null },
		status: 'queued',
		createdBy: uid,
		createdAt: serverTimestamp(),
		updatedAt: serverTimestamp(),
	});
	return ref.id;
};
